export default __webpack_public_path__ + "media/images/table_layouts/round-3bfdffb57aa84897afa9e2ec33c081ea.svg";